import { render } from "./EmployeeApprovedPrs.vue?vue&type=template&id=38ff957f"
import script from "./EmployeeApprovedPrs.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedPrs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__